import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d7f22c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w100 fh-c edit-component" }, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_role_select = _resolveComponent("role-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_service_desk_tag_select = _resolveComponent("service-desk-tag-select")!
  const _component_service_desk_select = _resolveComponent("service-desk-select")!
  const _component_ewei_tags_select = _resolveComponent("ewei-tags-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.showModal,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showModal) = $event)),
    title: "批量修改客服",
    style: {"width":"600px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "cancel",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        onClick: _ctx.handleSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_a_form, {
        "label-col": { span: 6 },
        "wrapper-col": { span: 18 },
        labelAlign: "left"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, _mergeProps({ label: "客服角色" }, _ctx.validateInfos['role.id']), {
            default: _withCtx(() => [
              _createVNode(_component_role_select, {
                modelValue: _ctx.formData.role.id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.role.id) = $event)),
                "filter-role-name-key": _ctx.filterRoleNameKey,
                allowClear: ""
              }, null, 8, ["modelValue", "filter-role-name-key"])
            ]),
            _: 1
          }, 16),
          (!_ctx.hadSunloginWeb)
            ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                key: 0,
                label: "所属客服组"
              }, _ctx.validateInfos['serviceDeskIds']), {
                default: _withCtx(() => [
                  _createVNode(_component_service_desk_tag_select, {
                    modelValue: _ctx.formData.serviceDeskIds,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.serviceDeskIds) = $event)),
                    serviceDeskStatus: "1",
                    onChange: _ctx.checkDefaultServiceDesk,
                    allowClear: ""
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }, 16))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, _mergeProps({ label: "首选客服组" }, _ctx.validateInfos['defaultServiceDesk.id'], { "error-message": 'aaa' }), {
            default: _withCtx(() => [
              _createVNode(_component_service_desk_select, {
                modelValue: _ctx.formData.defaultServiceDesk.id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.defaultServiceDesk.id) = $event)),
                serviceDeskStatus: "1",
                "option-ids": _ctx.serviceDeskOptionIds,
                hadSunloginWeb: _ctx.hadSunloginWeb
              }, null, 8, ["modelValue", "option-ids", "hadSunloginWeb"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_a_form_item, { label: "标签" }, {
            default: _withCtx(() => [
              _createVNode(_component_ewei_tags_select, {
                who: "user",
                onTagChange: _ctx.handleTagChange
              }, null, 8, ["onTagChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "并发会话上限范围",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_group, {
                compact: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, _mergeProps(_ctx.validateInfos['minConcurrentChatNumber'], { style: {"width":"calc(50% - 16px)"} }), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formData.minConcurrentChatNumber,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.minConcurrentChatNumber) = $event)),
                        type: "number"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 16),
                  _createVNode(_component_a_input, {
                    style: {"width":"30px","pointer-events":"none","background-color":"#fff"},
                    placeholder: "~",
                    disabled: ""
                  }),
                  _createVNode(_component_a_form_item, _mergeProps(_ctx.validateInfos['maxConcurrentChatNumber'], { style: {"width":"calc(50% - 15px)"} }), {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formData.maxConcurrentChatNumber,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.maxConcurrentChatNumber) = $event)),
                        type: "number"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}